import { Number, Status } from '@iqueue/ui-kit'

export default function SensorsTrafficLight({
  sensors: {
    bad: badSensorsCont = 0,
    good: goodSensorsCont = 0,
    normal: normalSensorsCont = 0,
  } = {}
}) {
  // const max = goodSensorsCont + normalSensorsCont + badSensorsCont

  return <>
    {/* TODO add popup hints */}
    <Status>
      <Number fixed={ 0 }>{ goodSensorsCont }</Number>
    </Status>
    <Status warning>
      <Number fixed={ 0 }>{ normalSensorsCont }</Number>
    </Status>
    <Status error>
      <Number fixed={ 0 }>{ badSensorsCont }</Number>
    </Status>
  </>
}
